<template>
  <div class="animated fadeIn">
    <div class="page-header d-flex" style="margin: 12px 12px 5px 12px;">
      <h4 class="page-title">
        <i class="fas fa-list-alt"></i>
        Policy
      </h4>
      <ul class="breadcrumbs ml-auto">
          <li class="nav-home mr-1">
              <a href="#">
                <i class="fas fa-home text-muted"></i>
              </a>
          </li>
          <li class="nav-item">
              <a class="font_15" href="#">WMDS</a>
          </li>
          <li class="separator">
              <i class="fa fa-angle-right"></i>
          </li>
          <li class="nav-item">
              <a class="font_15 font-weight-bold" href="#">Policy</a>
          </li>
      </ul>
    </div>

    <b-row>
      <b-col lg="12" xl="12">
        <b-card>
          <b-row>
            <b-col>
              <strong>Policy</strong>
              <small>Setting up Check methods.</small>
              <small class="float-right">{{model.created_at | datetime}}</small>
            </b-col>
          </b-row>
          <hr>
          <b-row>
            <b-col md="8">
              <b-form-group v-if="model && model.policy">
                <label for="ph_policy" v-b-tooltip.hover>Policy Description
                </label>
                <b-form-input type="text" id="ph_descrip" v-model="model.description" :plaintext="lock"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="4">
              <b-form-group>
                <label for="ph_links" v-b-tooltip.hover title="Enter the maximum sublink to navigate within a page. Ignore any excess links. Normally, if too many links exist on one page, you can reach the maximum navigation page before navigating to the other to prevent it from not being checked in a balanced way. You can specify it within the range of 1-1,000.">Sub Page Link
                  <span class="text-info">
                    <i style="cursor:pointer" class="fas fa-question-circle"></i>
                  </span>
                </label>
                <b-form-input type="number" id="ph_links" :min="1" :max="1000" v-model="model.policy.links" :plaintext="lock"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group>
                <label for="ph_limit" v-b-tooltip.hover title="Total number of pages to check on the inspection site. End the check when the entered number is reached. can be specified within the range of 1 to license limit.">Maximum Navigation Page
                  <span class="text-info">
                    <i style="cursor:pointer" class="fas fa-question-circle"></i>
                  </span>
                </label>
                <b-form-input type="number" id="ph_limit" :min="10" :max="limit" v-model="model.policy.limit" :plaintext="lock"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group>
                <label for="ph_depth" v-b-tooltip.hover title="Enter whether to check by moving (path) the link from the first page to the next. Can be specified within the range 1-100.">Maximum path depth
                  <span class="text-info">
                    <i style="cursor:pointer" class="fas fa-question-circle"></i>
                  </span>
                </label>
                <b-form-input type="number" id="ph_depth" :min="1" :max="100" v-model="model.policy.depth" :plaintext="lock"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="4">
              <b-form-group>
                <label for="ph_timeout" v-b-tooltip.hover title="Time to wait for page loading. can be specified within the range of 1-30.">TimeOut(Second)
                  <span class="text-info">
                    <i style="cursor:pointer" class="fas fa-question-circle"></i>
                  </span>
                </label>
                <b-form-input type="number" id="ph_timeout" :min="1" :max="30" v-model="model.policy.timeout" :plaintext="lock"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group>
                <label for="ph_delay" v-b-tooltip.hover title="Time to wait before moving to a new page. can be specified within the range of 1 to 10,000.">Check Speed(Millisecond)
                  <span class="text-info">
                    <i style="cursor:pointer" class="fas fa-question-circle"></i>
                  </span>
                </label>
                <b-form-input type="number" id="ph_delay" :min="0" :max="10000" v-model="model.policy.delay" :plaintext="lock"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <template v-if="lock">
            <template v-if="model.is_del">
              <!-- <b-button size="sm" variant="success" @click="revive"> 되살리기 </b-button> -->
              <span>was deleted policy.</span>
            </template>
            <template v-else>
              <b-button size="sm" variant="primary" @click="edit" class="btn-add"> Edit </b-button>
              <b-button size="sm" variant="danger" @click="remove"> Remove </b-button>
            </template>
          </template>
          <template v-else>
            <b-button class="btn-add" size="sm" variant="success" @click="save"> Save </b-button>
            <b-button size="sm" variant="default" @click="cancel" class="btn-cancel"> Cancel </b-button>
          </template>
          <b-button size="sm" class="float-right text-white" variant="secondary" @click="list"> List </b-button>
        </b-card>
        <hr>
        <siteList v-if="model.id" :policy_id="model.id" :enable_new="false"></siteList>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import App from './app.js'; export default Object.assign({}, App);
</script>
